import { Component, OnInit, ViewChild, Input, Output, ElementRef, EventEmitter } from '@angular/core';
import { NotificationsService } from '../../services/notifications.service';

type format = 'img' | 'pdf' | 'excel' | 'zip' | 'word';
@Component({
  selector: 'app-dropzone-documentos',
  templateUrl: './dropzone-documentos.component.html',
  styleUrls: ['./dropzone-documentos.component.scss'],
  host: { class: 'app-dropzone-documentos' }
})
export class DropzoneDocumentosComponent implements OnInit {

  @ViewChild('fileInput') input:ElementRef
  @ViewChild('fileInputMulti') inputMulti:ElementRef

  @Input('placeholder') placeholder:string = 'Arrastra o carga tus documentos'
  @Input('preview') preview:boolean = true
  @Input('formats') formats: format[] = ['pdf']
  @Input('multi') multi:boolean;
  @Input('less-padding') lessPadding:boolean
  @Input('esFacial') esFacial:boolean = false
  @Input('esPersonalizacion') esPersonalizacion:boolean = false
  @Input('multiDoc') multiDoc:boolean = false;
  @Input('lengthAllowed') lengthAllowed:number = 0;
  @Input('plan') plan:number;
  @Input('limitUpload') limitUpload:any = '';

  @Output()
  onconvert: EventEmitter<any> = new EventEmitter()
  @Output()
  ondrop: EventEmitter<any> = new EventEmitter()
  @Output()
  length: EventEmitter<any> = new EventEmitter()
  
  lengthTotal:number
  limitUploadMB:any = 0
  constructor(  public notify: NotificationsService) { }

  ngOnInit(): void {
  }

  handleClick() {
    this.multi ? this.inputMulti.nativeElement.click() : this.input.nativeElement.click()
  }

  allowDrop(e) {
    e.stopPropagation();
    e.preventDefault();
  }

  drop(e) {
    e.preventDefault();
    
    // RQ Plan Personalizado
    this.validarLimiteCargaPersonalizado()
    //Para contabilizar carga documentos
    this.lengthTotal = e.dataTransfer.files.length
    if(e.dataTransfer.files.length> this.lengthAllowed){
      this.notify.info('La cantidad de documentos supera a su plan actual.');
      return;
    }

    let files = e.dataTransfer.files
    this.validate(files)
  }

  change(e) {
    // RQ Plan Personalizado
    this.validarLimiteCargaPersonalizado()
    //Para contabilizar carga documentos
    this.lengthTotal = e.target.files.length
    if(e.target.files.length> this.lengthAllowed){
      this.notify.info('La cantidad de documentos supera a su plan actual.');
      return;
    }
    
    let files = e.target.files
    this.validate(files)
  }
  
  validate(files:File[]) {
    //validacion para tipo de plan
    let plan = 0
    if(this.plan != undefined){
      plan = this.plan
      localStorage.setItem('_upDoc_p',this.plan.toString())
    }else{
      plan = parseInt(localStorage.getItem('_upDoc_p'))
    }
    console.log('plan',plan)//

    let valid:boolean = false
    let counter:number = 0
    let limitePersonalizado:number = this.limitUploadMB * 1048576
    //console.log('limitePersonalizado', limitePersonalizado)

    while (!valid && counter < files.length) {

      switch (files[counter].type) {
        case 'image/jpeg': case 'image/png':
          if (this.formats.includes('img') && files[counter].size <= 262150 && !this.esFacial){
            valid = true
          }else if(this.formats.includes('img') && this.esFacial && files[counter].size <= 1048576){
            valid = true
          }else if(this.formats.includes('img') && this.esPersonalizacion && files[counter].size <= 1048576){
            valid = true
          } 

          break
        
        case 'application/pdf':
          //if (this.formats.includes('pdf')) valid = true
          //Plan Free - 5MB
          if (this.formats.includes('pdf') && plan == 1 && files[counter].size <= 5242880){
            valid = true
          //Plan Emprendedor - 50MB --52428800 // MOD 20 MB
          }else if(this.formats.includes('pdf') && plan == 2 && files[counter].size <= 20971520){
            valid = true
          //Plan Corporativo - 100MB --104857600 // MOD 50 MB
          }else if(this.formats.includes('pdf') && plan == 3 && files[counter].size <= 52428800){
            valid = true
          //Plan Personalizado - dinamic
          }else if(this.formats.includes('pdf') && plan == 4 && files[counter].size <= limitePersonalizado){
            //console.log('Peso archivo', files[counter].size)
            valid = true
          }

          break

        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        case 'application/vnd.ms-excel':
          valid = this.formats.includes('excel');
          break;
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          valid = this.formats.includes('word');
          break;
        case 'application/zip': case 'application/x-zip-compressed':
          if (this.formats.includes('zip')) valid = true
          break
      }
      counter ++
    }

    if (valid) {

      this.ondrop.emit(this.multi ? files : files[0])
      this.length.emit(this.lengthTotal)
      if (this.preview) this.getBase(files[0])
    } else {
      this.notify.info("No se puede cargar este archivo. validar nuevamente.");
    }

  }

  validarLimiteCargaPersonalizado(){
    var regex = /(\d+)/g;
    //console.log('limitUpload',this.limitUpload)
    if(this.limitUpload != ''){
      this.limitUploadMB = parseInt(this.limitUpload.match(regex))
      localStorage.setItem('_upLimit_p',this.limitUploadMB)
    }else{
      this.limitUploadMB = parseInt(localStorage.getItem('_upLimit_p'))
    }
    //console.log('limitUploadMB',this.limitUploadMB);
  }

  conversionLoading:boolean
  base:any
  getBase(img:any) {

    this.conversionLoading = true
    const reader = new FileReader
    reader.onload = e => {
      this.base = e.target.result
      this.conversionLoading = false
      this.onconvert.emit(this.base)
    }
    reader.readAsDataURL(img)
  
  }

  displaySize(size) {
    if (size < 1048576) {
      return (size / 1024).toFixed(2) + ' KB';
    } else {
      return (size / 1048576).toFixed(2) + ' MB';
    }
  }

}
